export const SYSTEM_NAME_ARRAY = [
  "EKOM-10",
  "EKOM-20",
  "EKOM-30",
  "EKOM-E50",
  "EKOM-E70",
  "EKOM-E100",
];

export const AVERAGE_WATER_USAGE_EKOM_VALUES = [
  "7300", "9125", "15512", "21900", "30112", "45625",
];
export const AVERAGE_WATER_USAGE_STANDARD_VALUES = [
  "10037", "18250", "27375", "45625", "68437", "91250",
];

export const AVERAGE_SALT_USAGE_EKOM_VALUES = [
  "82,13",
  "164,25",
  "383,25",
  "547,5",
  "730",
  "1095",
];
export const AVERAGE_SALT_USAGE_STANDARD_VALUES = ["219", "438", "657", "1095", "1642", "2190"];

export default SYSTEM_NAME_ARRAY;